import React from "react";

const SingleCourseSkeleton = () => {
  return (
    <div className="px-4 mx-auto sm:max-w-5xl sm:px-6 lg:max-w-7xl lg:px-8 max-w-7xl rounded-xl dark:bg-gray-800 dark:border-gray-700 my-20 animate-pulse">
      {/* Breadcrumbs Skeleton */}
      <div className="flex items-center space-x-2 mb-4">
        <div className="h-4 bg-gray-300 rounded w-20"></div>
        <div className="h-4 bg-gray-300 rounded w-6"></div>
        <div className="h-4 bg-gray-300 rounded w-24"></div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-6 lg:grid-cols-6 gap-4">
        <div className="sm:col-span-1 md:col-span-6 lg:col-span-3 my-5">
          {/* Image Skeleton */}
          <div className="w-full h-48 bg-gray-300 rounded-lg"></div>

          {/* Text Skeleton */}
          <div className="space-y-2 mt-5">
            <div className="h-6 bg-gray-300 rounded w-1/2"></div>
            <div className="h-6 bg-gray-300 rounded w-1/4"></div>
            <div className="h-10 bg-gray-300 rounded w-full mt-5"></div>
          </div>
        </div>

        <div className="sm:col-span-1 md:col-span-2 lg:col-span-3 my-5">
          {/* Video Skeleton */}
          <div className="w-full h-48 bg-gray-300 rounded-lg"></div>
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-6 md:grid-cols-6 lg:grid-cols-4 gap-4 mt-5">
        {/* Info Cards Skeleton */}
        {Array(4).fill(0).map((_, index) => (
          <div key={index} className="flex items-center gap-2">
            <div className="w-6 h-6 bg-gray-300 rounded-full"></div>
            <div>
              <div className="h-4 bg-gray-300 rounded w-20"></div>
              <div className="h-4 bg-gray-300 rounded w-10 mt-1"></div>
            </div>
          </div>
        ))}
      </div>

      {/* Tabs Skeleton */}
      <div className="mt-8 space-y-2">
        <div className="h-6 bg-gray-300 rounded w-32"></div>
        <div className="h-40 bg-gray-300 rounded w-full"></div>
      </div>

      {/* Reviews Skeleton */}
      <div className="max-w-xl mt-8 space-y-4">
        <div className="h-6 bg-gray-300 rounded w-48"></div>
        {Array(3).fill(0).map((_, index) => (
          <div key={index} className="space-y-2">
            <div className="h-4 bg-gray-300 rounded w-24"></div>
            <div className="h-3 bg-gray-300 rounded w-full"></div>
            <div className="h-3 bg-gray-300 rounded w-3/4"></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SingleCourseSkeleton;
